var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"container--large faq padding-left-right"},[_c('h1',{staticClass:"text-center"},[_vm._v("Page not found")])])}
var staticRenderFns = []

export { render, staticRenderFns }